import React, { useState, useEffect } from "react";
import axios from "axios";
import "./IpWhitelistPage.css";

const IpWhitelistPage = () => {
  const [ip, setIp] = useState("");
  const [isWhitelisted, setIsWhitelisted] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/check-ip`)
      .then((res) => {
        setIp(res.data.ip);
        setIsWhitelisted(res.data.isWhitelisted);
      })
      .catch((err) => console.error("Error fetching IP:", err));
  }, []);

  const handleSendOtp = () => {
    axios
      .post(`${process.env.REACT_APP_API_URL}/api/send-ip-change-otp`, { ip })
      .then(() => {
        setOtpSent(true);
      })
      .catch((err) => console.error("Error sending OTP:", err));
  };

  const handleWhitelistIp = () => {
    axios
      .post(`${process.env.REACT_APP_API_URL}/api/whitelist-ip`, { ip, otp })
      .then(() => {
        alert("IP successfully whitelisted");
        setIsWhitelisted(true);
      })
      .catch((err) => {
        alert("Failed to whitelist IP: " + err.response.data);
      });
  };

  return (
    <div className="ip-whitelist-container">
      <h1>IP Whitelist Management</h1>
      <p>Current IP: {ip}</p>
      {isWhitelisted ? (
        <p>This IP is already whitelisted.</p>
      ) : (
        <>
          {!otpSent ? (
            <button onClick={handleSendOtp}>Send OTP</button>
          ) : (
            <div>
              <input
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Enter OTP"
                required
              />
              <button onClick={handleWhitelistIp}>Whitelist This IP</button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default IpWhitelistPage;
